import _ from 'lodash'

export default MobilePhone

/** @ngInject */
function MobilePhone(CommonRegex) {
    const phoneRegex = CommonRegex.phone

    const formatPhoneToPlus33 = function (phone) {
        if (phoneRegex.plus33.test(phone)) {
            return phone
        } else if (phoneRegex['0033'].test(phone)) {
            return `+${phone.slice(2)}`
        } else if (phoneRegex['06or07'].test(phone)) {
            return `+33${phone.slice(1)}`
        }
        return phone
    }

    const formatPhoneTo0607 = function (phone) {
        if (phoneRegex.plus33.test(phone)) {
            return _.replace(phone, /\+33(.*)/g, '0$1')
        } else if (phoneRegex['0033'].test(phone)) {
            return _.replace(phone, /0033(.*)/g, '0$1')
        } else if (phoneRegex['06or07'].test(phone)) {
            return phone
        }
        return phone
    }

    const formatPhoneToSpacePhone = (v) => _.replace(v, /(.{2})(?=.)/g, '$1 ')

    return {
        phoneRegex,
        formatPhoneToPlus33,
        formatPhoneTo0607,
        formatPhoneToSpacePhone,
    }
}



// WEBPACK FOOTER //
// ./src/services/mobilePhone/mobilePhone.js